var _rect, _defs;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSquaredMenu(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 27,
    viewBox: "0 0 25 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 25,
    height: 27,
    fill: "url(#pattern0)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("pattern", {
    id: "pattern0",
    patternContentUnits: "objectBoundingBox",
    width: 1,
    height: 1
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#image0_325_1152",
    transform: "matrix(0.01 0 0 0.00925926 0 0.037037)"
  })), /*#__PURE__*/React.createElement("image", {
    id: "image0_325_1152",
    width: 100,
    height: 100,
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABkCAYAAABw4pVUAAAACXBIWXMAAAsTAAALEwEAmpwYAAAByklEQVR4nO2cQU7DQBTFcg665u5k0ZMhJNILGI3UDVUDTZpmXvTtA8yXbJVF+8QwiIiIiIiIBAK8A2fgwvO0N0bg5N31Mb7Yns+/olDs7pIg7ZPxKj68u5CN/kzN8e3dhdwa3Os9it3t9mC6GAySJQaDZInBIFliMEiWGAySJQaDZInBIFliMEiWGAySJQaDZInBIFliMEiWGAySJQaDZInhAEEm+vxANVW6uyRIGyT0+Al3rHR3SZDT9Qf6rWlvvnl3BU1cq7vRx3m6vjUbo+pdEREREemK6/d91v5LYpRZoeP6fVbMmUKr+4dx/Z735eIv9nqPYne7PZguBoNkicEgWWIwSJYYDJIlBoNkicEgWWIwSJYYDJIlBoNkicEgWWIwSJYYDJIlBoNkicEgWWI4QJBSK3Rcv8+KGV8YxPX7HVy/r6XaCh3X7yIiIiIVcf3+FK7f/8H1+5FW6Lh+nxVzqfQ/5x/m9sW93qPY3W4PpovBIFliMEiWGAySJQaDZInBIFliMEiWGAySJQaDZInBIFliMEiWGAySJQaDZInBIFliMEiWGA4QpNQKHdfvs2LGFwZx/X4H1+9rqbZCx/W7iIiIiIgMdfgB5CTn3qFIZJEAAAAASUVORK5CYII="
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquaredMenu);
export default __webpack_public_path__ + "static/media/squared-menu.ae611e2b8abc823e6530a939014896e3.svg";
export { ForwardRef as ReactComponent };